// extracted by mini-css-extract-plugin
export default {"cls1":"kqQlhkh7ZPNdbRJtzuFY","cls2":"ORs85VC0T3Dn9pUhRSvH kqQlhkh7ZPNdbRJtzuFY"};